import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { useQuery } from "@tanstack/react-query";

import { getDairyCowTypes, getDairyCowTypesAdmin } from "services";

import { getEnvironment, injectNames } from "utils";

import { DEFAULT_CACHE_TIME, GET_DAIRY_COW_TYPES } from "consts";

import { DairyCowType } from "models";

export const useGetDairyCowTypes = ({ enabled }: { enabled?: boolean } = {}) => {
  // Not having { useSuspense: false } caused unintended UI behavior — like a drawer opening and closing on mount,
  // due to remounting triggered by Suspense fallback.
  // DO NOT REMOVE unless you're explicitly handling Suspense with fallback UIs.
  const { t } = useTranslation("footprintingDairy", { useSuspense: false });
  const isAdmin = getEnvironment().admin;

  // Translate in select, not queryFn, so the cached data stays language-neutral and names follow language and namespace loads.
  const withTranslatedNames = useCallback((cowTypes: DairyCowType[]) => injectNames(cowTypes, t, "cowTypes"), [t]);

  return useQuery({
    queryKey: [GET_DAIRY_COW_TYPES, { enabled }, isAdmin],
    queryFn: () => (isAdmin ? getDairyCowTypesAdmin({ enabled }) : getDairyCowTypes({ enabled })),
    select: withTranslatedNames,
    gcTime: DEFAULT_CACHE_TIME,
    staleTime: DEFAULT_CACHE_TIME,
  });
};
